/** Logical keys; provisioning allocates workspace-specific template and column UUIDs. */
export enum OttopilotAnnouncementsWorkspaceCapabilityUdoTemplateKey {
    announcement = "6063daec-565f-45e4-a17a-ced339e73990",
    tracking = "c0cdffb4-c06e-4a8d-a709-ec81ae6acaf7",
}
